export enum PurchaseHistoryTab {
  All = "all",
  Purchases = "purchases",
  Expenses = "expenses",
}
